#import "../../DepartmentFields.graphql"
mutation DepartmentUpdate($input: DepartmentUpdateInput!) {
  departmentUpdate(input: $input) {
    department {
      ...DepartmentFields
    }
  }
}
